
import React,{useState,useRef,memo,useCallback,useEffect,useLayoutEffect} from 'react'
import {animateParallax,getAnimationModel,animateIntersect,setInitialAnimIntersectState,setFinalAnimIntersectState} from './CanvasAnimator'
import Globals from 'system/Globals'
import CharStyleOverrides from 'system/components/CharStyleOverrides'
import {useInteraction} from './useInteraction'

function TEXTButtonComponent(props){

    const [inline,setInline] = useState({})
    const [text,setText] = useState(0)
    const [textCss, setTextCss] = useState({});
    const [resizeCount, setResizeCount] = useState(0)

    let bLoaded=false
    const refEle = useRef()
    const refFormat = useRef()
    const refOrigOffset = useRef(0)
    const refAnimationModel = useRef({})

    const link = props.model.content ? props.model.content.module : null;

    const onClick = useInteraction({
        link,
        refEle,
        pageId: props.pageId,
        nid: props.nid,
        flatMenuItems: props.flatMenuItems,
        onScrollToEvent: props.onScrollToEvent,
        setCurrentPage: props.setCurrentPage,
        socket: props.socket,
        socketPrefs: props.socketPrefs
    })

    function onLoad(){
        if(!bLoaded){
            props.onLoad(props.index,refEle.current,props.model)
            bLoaded=true
            if(props.renderOnly===true){
                refAnimationModel.current = getAnimationModel(refEle.current,refFormat.current.animation)
                setFinalAnimIntersectState(refEle.current,refAnimationModel.current)
            }
        }
    }

    useEffect(()=>{
        refOrigOffset.current=refEle.current.offsetLeft
        if(refFormat.current && refFormat.current.animation && refFormat.current.animation.typeName){
            refAnimationModel.current = getAnimationModel(refEle.current,refFormat.current.animation)
            if(props.renderOnly===true){
                setFinalAnimIntersectState(refEle.current,refFormat.current.animation)
            }
        }
    },[inline])

    const refResizeTimer = useRef(null);
    useEffect(() => {
        const onResize = () => {
            clearTimeout(refResizeTimer.current);
            refResizeTimer.current = setTimeout(() => setResizeCount(c => c + 1), 150);
        };
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
            clearTimeout(refResizeTimer.current);
        };
    }, []);

    useLayoutEffect(() => {
        if (!refEle.current || !text) return;

        const container = refEle.current;
        const containerWidth = container.offsetWidth;
        const containerHeight = container.offsetHeight;
        if (containerWidth <= 0 || containerHeight <= 0) return;

        const outerSpan = container.querySelector(':scope > span');
        if (!outerSpan) return;

        if (textCss.fontSize) {
            outerSpan.style.fontSize = textCss.fontSize;
        }
        outerSpan.querySelectorAll('span[style]').forEach(span => {
            if (span.dataset.origFs) {
                span.style.fontSize = span.dataset.origFs;
            } else {
                const fs = parseFloat(span.style.fontSize);
                if (fs > 0) span.dataset.origFs = span.style.fontSize;
            }
        });

        outerSpan.style.display = 'block';
        outerSpan.style.width = '100%';

        const applyScale = (s) => {
            const fs = parseFloat(outerSpan.style.fontSize);
            if (fs > 0) outerSpan.style.fontSize = (fs * s) + 'px';
            outerSpan.querySelectorAll('span[style]').forEach(span => {
                const spanFs = parseFloat(span.style.fontSize);
                if (spanFs > 0) span.style.fontSize = (spanFs * s) + 'px';
            });
        };

        let textHeight = outerSpan.scrollHeight;
        if (textHeight <= 0) return;

        const cmsFontSize = parseFloat(textCss.fontSize) || 0;
        const isSingleLine =
            (cmsFontSize > 0 && containerHeight < cmsFontSize * 1.5) ||
            (textHeight <= containerHeight * 1.1 &&
            (() => {
                const saved = outerSpan.style.whiteSpace;
                outerSpan.style.whiteSpace = 'nowrap';
                const h = outerSpan.scrollHeight;
                outerSpan.style.whiteSpace = saved;
                return Math.abs(h - textHeight) < 2;
            })());

        if (isSingleLine) {
            const savedWS = outerSpan.style.whiteSpace;
            const savedD = outerSpan.style.display;
            outerSpan.style.display = 'inline';
            outerSpan.style.whiteSpace = 'nowrap';
            const textWidth = outerSpan.getBoundingClientRect().width;
            outerSpan.style.display = savedD;
            outerSpan.style.whiteSpace = savedWS;

            if (textWidth <= 0) return;
            const scale = (containerWidth / textWidth) * 0.975;
            if (Math.abs(scale - 1) < 0.01) return;
            applyScale(scale);
        } else {
            let targetHeight = containerHeight * 0.975;
            let ratio = targetHeight / textHeight;
            if (Math.abs(ratio - 1) < 0.02) return;

            let scale = Math.sqrt(ratio);
            applyScale(scale);

            textHeight = outerSpan.scrollHeight;
            if (textHeight > 0) {
                ratio = targetHeight / textHeight;
                if (Math.abs(ratio - 1) > 0.02) {
                    applyScale(ratio);
                }
            }
        }
    }, [inline, text, textCss, resizeCount]);

    const onScroll = useCallback((scrollLeft,scale,pageWidth)=>{
        animateParallax(refEle.current,refAnimationModel.current,scrollLeft,pageWidth)
    },[props.model.animation,refEle])

    useEffect(() => {
        if (props.pageState === "animPage" && inline && refAnimationModel.current && refAnimationModel.current.animations) {
            animateIntersect(refEle.current,refAnimationModel.current)
        }
    }, [props, inline])

    const onIntersect = useCallback((evt,threshold)=>{
        if(evt.detail.isIntersecting )
        {
            if(evt.detail.intersectionRatio >=threshold)
                animateIntersect(refEle.current,refAnimationModel.current)
        }
        else if(evt.detail.intersectionRatio <=0.001)
            setInitialAnimIntersectState(refEle.current,refAnimationModel.current)
    },[refEle])

    const onAnim = useCallback((evt,threshold)=>{
        if(evt)
        {
            animateIntersect(refEle.current,refAnimationModel.current)
        }
        else {
            setInitialAnimIntersectState(refEle.current,refAnimationModel.current)
        }
    },[refEle])

    useEffect(() => {
        if (text && textCss && props) {
            onLoad()
        }
    }, [text, textCss, props])

    useEffect(()=>{

        refFormat.current = Globals.instance().getCanvasFormat(props.model.formats,props.format)

        let style ={position:'absolute',transform: 'translateZ(0), perspective: 1000px',willChange:'transform', 'cursor': 'pointer'}
        if(refFormat.current.style){ style = Object.assign(style,refFormat.current.style) }

        if (refFormat.current.html_text['text']) {
            setText(refFormat.current.html_text)
        }

        function translateCss(objCss) {
            let array = Object.entries(objCss);
            let reactCss = {};
            array.forEach((obj, i) => {
              switch (obj[0]) {
                case 'font-family':
                  reactCss['fontFamily'] = obj[1];
                  break;
                case 'font-weight':
                  reactCss['fontWeight'] = obj[1];
                  break;
                case 'font-size':
                  reactCss['fontSize'] = obj[1] + "px";
                  break;
                case 'text-align':
                  reactCss['textAlign'] = obj[1];
                  reactCss['display'] = 'block';
                  break;
                case 'color':
                  reactCss['color'] = obj[1];
                  break;
                case 'letter-spacing':
                    reactCss['letterSpacing'] = obj[1];
                    break;
                case 'line-height':
                    reactCss['lineHeight'] = obj[1];
                    break;
                default:
                  break;
              }
            })
            return reactCss
        }

        setTextCss( translateCss(refFormat.current.html_text['css']) )

        if(refFormat.current.animation){
            if(refFormat.current.animation.typeName==='parallax'){
                props.setScrollCallback(onScroll,props.index)
                style.willChange='transform'
            }
            else if(refFormat.current.animation.typeName==='page'){
                props.onIntersect(onIntersect,props.index)
                props.onAnim(onAnim, props.index)
                style.willChange='transform, scale, opacity'
            }
        }
        setInline(style)

        return ()=>{}
    },[props])

    function onError(evt){
        console.error("TEXTButton load error"+ bLoaded, evt.target.src)
        if(!bLoaded){
            onLoad()
        }
    }

    return (
        <div id={refFormat.current && "component_dim_file_" + refFormat.current.component} onClick={onClick} style={inline} onError={onError} ref={refEle} className={'force3d'} data-opacity={inline.opacity}>
            {text && <span style={textCss}><span dangerouslySetInnerHTML={{__html: CharStyleOverrides(text, props.format, null)}} /></span>}
        </div>
    )

}

const TEXTButton = memo( TEXTButtonComponent, (prev,next)=>{
    return false
})

export {TEXTButton}
